import moment from 'moment'
import { useTranslation } from 'react-i18next'

import { DateFieldModel } from '@types'

import { SelectDate } from '@modules/_shared/components/SelectDate'

type SubmitterFieldDateProps = {
  field: DateFieldModel
  disabled?: boolean
  onChange: (updates: Partial<DateFieldModel>) => void
}

export const SubmitterFieldDate: React.FC<SubmitterFieldDateProps> = ({
  field,
  disabled = false,
  onChange,
}: SubmitterFieldDateProps) => {
  const { t } = useTranslation()

  return (
    <SelectDate
      fullWidth
      disabled={disabled}
      required={field.required}
      placeholder={t('modules_project-forms_components_FormSubmitter_components_SubmitterFieldDate_placeholder')}
      onChange={(value) => value && onChange({ value: moment(value).format('YYYY-MM-DD') })}
      date={field.value ? moment(field.value).toDate() : undefined}
      label={field.label}
    />
  )
}
